export const config = {
  eventGroup: 'jxsj_znq_mo_20260928',
  name: '《剑侠世界端游》2026年10月18周年庆百连抽H5',
  identify: 'jxsj2',
  eventTags: ['jxsj', 'mo', 'znq']
};

const DEFAULT_LOGIN_SESSION_KEY = 'ANNIVERSARY_LOGIN_SOURCE';
const DEFAULT_LOGIN_SESSION_MAX_AGE = 5 * 60 * 1000;

function getDefaultStorage() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }
  return window.sessionStorage;
}

export default function createTracker(report, getDiffRouteTime, options = {}) {
  const storage = options.storage || getDefaultStorage();
  const getNow = options.getNow || (() => Date.now());
  const loginSessionKey = options.loginSessionKey || DEFAULT_LOGIN_SESSION_KEY;
  const loginSessionMaxAge = options.loginSessionMaxAge || DEFAULT_LOGIN_SESSION_MAX_AGE;

  function clearLoginSession() {
    if (storage) {
      storage.removeItem(loginSessionKey);
    }
  }

  return {
    loadPage: function() {
      report({
        eventName: 'load_page',
        eventDescription: '页面加载(默认上报，页面全部加载完才上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    pageLeave: function() {
      report({
        eventName: 'page_leave',
        eventDescription: '离开页面(默认上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    loadPageStart: function() {
      report({
        eventName: 'load_page_start',
        eventDescription: '页面加载(默认上报，进入页面就上报)',
        eventDataValue: {
          td_pl: getDiffRouteTime()
        },
        types: {
          td_pl: checkTypeHOF('int')
        }
      });
    },
    /**
     * @param {string} [title] - 按钮名称：登录；我要参与；退出
     */
    clickHomepageButton: function(title) {
      report({
        eventName: 'click_homepage_button',
        eventDescription: '点击首页按钮',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 按钮名称：预约送礼
     */
    clickPageNavigation: function(title) {
      report({
        eventName: 'click_page_navigation',
        eventDescription: '点击页面导航',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    /**
     * @param {string} [title] - 按钮名称：抽奖一次；抽奖十次
     */
    clickLottery: function(title) {
      report({
        eventName: 'click_lottery',
        eventDescription: '点击抽奖按钮',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },
    clickHelpFriend: function() {
      report({
        eventName: 'click_help_friend',
        eventDescription: '客态页点击帮TA点赞'
      });
    },
    clickGuestJoin: function() {
      report({
        eventName: 'click_guest_join',
        eventDescription: '客态页点击我也要参加'
      });
    },
    clickGuestInvite: function() {
      report({
        eventName: 'click_guest_invite',
        eventDescription: '客态页点击邀好友点赞'
      });
    },
    /**
     * @param {string} [title] - 按钮名称：登录；前往绑定手机；我已绑定手机；立即激活；确定激活；取消
     */
    clickAuthButton: function(title) {
      report({
        eventName: 'click_auth_button',
        eventDescription: '点击链路按钮',
        eventDataValue: {
          title: title
        },
        types: {
          title: checkTypeHOF('string')
        }
      });
    },

    /**
     * 只保存登录恢复上下文；当前 CSV 未声明 login_start 事件，避免上报后台不存在的埋点。
     *
     * @param {string} source 受保护入口来源。
     * @returns {{source: string, startedAt: number}|null} 暂存的登录链路上下文。
     */
    loginStart: function(source) {
      const session = {
        source: source || 'unknown',
        startedAt: getNow()
      };
      if (storage) {
        storage.setItem(loginSessionKey, JSON.stringify(session));
      }
      return session;
    },

    /**
     * 登录成功后读取同一来源并清理上下文；当前 CSV 未声明 login_success，故不额外上报。
     *
     * @returns {{source: string, duration: number}|null} 恢复结果或空值。
     */
    loginSuccess: function() {
      if (!storage) {
        return null;
      }
      const rawSession = storage.getItem(loginSessionKey);
      if (!rawSession) {
        return null;
      }

      let session = null;
      try {
        session = JSON.parse(rawSession);
      } catch (e) {
        clearLoginSession();
        return null;
      }

      const startedAt = Number(session.startedAt);
      const now = getNow();
      // XPASS 取消/失败并不一定刷新页面，过期保护避免旧来源在之后登录时被误恢复。
      if (!Number.isFinite(startedAt) || now - startedAt > loginSessionMaxAge) {
        clearLoginSession();
        return null;
      }

      const source = session.source || 'unknown';
      const duration = Math.max(0, now - startedAt);
      clearLoginSession();
      return { source, duration };
    },

    /**
     * XPASS 取消登录时清理来源上下文，避免后续自然登录误恢复旧动作。
     *
     * @returns {null} 固定空值，便于页面 Store 作为终止分支处理。
     */
    loginCancel: function() {
      clearLoginSession();
      return null;
    },

    /**
     * XPASS 登录失败时清理来源上下文，失败链路不恢复旧业务入口。
     *
     * @returns {null} 固定空值，便于页面 Store 作为终止分支处理。
     */
    loginFailure: function() {
      clearLoginSession();
      return null;
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
